import { jsx } from "@emotion/react/jsx-runtime";
import { useContext } from "react";
import headingLevelContext from "./headingLevelContext.mjs";
function Section(_ref) {
  let {
    children,
    adjustLevel = 1
  } = _ref;
  let level = useContext(headingLevelContext);
  return /* @__PURE__ */jsx(headingLevelContext.Provider, {
    value: level + adjustLevel,
    children
  });
}
export { Section as default };